import {BaseService} from '../baseService.js';

/* 
 * Handles Auto Groups
 */
export class AutoGroupService extends BaseService {

	constructor() {	
		super();
	}
	
	async getAutoGroupConfigs(dataType) {
		var params = '';
		if (dataType) {
			params = '?dataType=' + encodeURIComponent(dataType);
		}
		var data = await this.makeGETRequest('/api/resource/auto-groups' + params);
		return data;
	}

	async getFieldDefinitions(dataType) {
		var data = await this.makeGETRequest('/api/resource/auto-groups/field-definitions/' + dataType);
		return data;
	}

	async saveAutoGroup(autoGroup, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/auto-groups/' + autoGroup.autoGroupId, autoGroup);
		} else {
			saved = await this.makePOSTRequest('/api/resource/auto-groups', autoGroup);
		}
		return saved;
	}	
	
	async deleteAutoGroup(autoGroupId) {		
		var result = await this.makeDELETERequest('/api/resource/auto-groups/' + autoGroupId);		
		return result;
	}
	
	async activateAutoGroup(autoGroupId) {	
		var result = await this.makePUTRequest('/api/resource/auto-groups/' + autoGroupId + '/activate');
		return result;
	}	

	async inactivateAutoGroup(autoGroupId) {	
		var result = await this.makePUTRequest('/api/resource/auto-groups/' + autoGroupId + '/inactivate');
		return result;
	}	
	
};
